export enum ShippingMethodEnum {
  LAND = "10",
  AIR = "20",
  SEA = "30",
}
